//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'TransferirModal',
  props: {
    filtros: null,
    passo: null,
    idPerfilFiltro: {
      type: [Number, String, null],
      default: null,
    },
  },
  data() {
    return {
      fluxoExecucaoResource: this.$api.workflowPassos(this.$resource),
      perfilResources: this.$api.perfil(this.$resource),
      estruturaUsuarioResources: this.$api.estruturaUsuario(this.$resource),
      usuarioResources: this.$api.usuario(this.$resource),
      usuarioClienteResources: this.$api.usuarioCliente(this.$resource),
      dialog: false,
      tipoAprovador: null,
      perfis: [],
      valid: true,
      estruturas: [],
      usuarios: [],
      usuariosCliente: [],
      idUsuarioCliente: null,
      usuariosAprovadores: null,
      grupos: null,
      subgrupos: null,
      rules: {
        required: value => !!value || this.$t('message.campo_obrigatorio'),
        requiredArray: value => (!!value && !!value.length) || this.$t('message.campo_obrigatorio'),
      },
      tipoAprovadores: [
        {
          descricao: this.$t('label.workflow_solicitante_usuario'),
          value: 'usuario',
        },
        {
          descricao: this.$t('label.workflow_solicitante_grupo'),
          value: 'grupo',
        },
      ],
    };
  },
  computed: {
    ehUsuario() {
      return this.tipoAprovador === 'usuario';
    },
    ehGrupo() {
      return this.tipoAprovador === 'grupo';
    },
    ehCliente() {
      return !!this.passo.passocliente;
    },
  },
  methods: {
    transferir() {
      if (!this.$refs.form.validate()) return;
      if (this.passo.passocliente && this.passo.id) {
        this.transferirPassoCliente();
      } else if (this.passo.id) {
        this.transferirPasso();
      } else {
        this.transferirPassos();
      }
    },
    transferirPassos() {
      this.fluxoExecucaoResource.transferirPassos(
        {
          idTipo: this.filtros.tipo.id,
        }, this.preencherParametrosPassos())
        .then(this.transferidoComSucesso)
        .catch(this.erroRequisicao);
    },
    transferirPasso() {
      this.fluxoExecucaoResource.transferirPasso(
        {
          idPasso: this.passo.id,
          idFluxo: this.passo.idFluxoExecucao,
        }, this.preencherParametrosPasso())
        .then(this.transferidoComSucesso)
        .catch(this.erroRequisicao);
    },
    preencherParametrosPasso() {
      const parametros = {};
      parametros.usuarios = this.usuariosAprovadores || [];
      parametros.grupos = this.grupos || [];
      parametros.subgrupos = this.subgrupos || [];
      return parametros;
    },
    preencherParametrosPassos() {
      const parametros = this.preencherParametrosPasso();
      if (this.passo.idAprovador && this.passo.idAprovador) {
        parametros.idAprovador = this.passo.idAprovador;
      }
      if (this.filtros.solicitante && this.filtros.solicitante.id) {
        parametros.idSolicitante = this.filtros.solicitante.id;
      }
      parametros.idTipo = this.filtros.tipo.id;
      parametros.idUsuarioCliente = this.idUsuarioCliente;
      parametros.passo = this.passo.tarefaAprovacao;
      parametros.passoCliente = this.passo.passocliente;
      return parametros;
    },
    transferirPassoCliente() {
      this.fluxoExecucaoResource.transferirPassoCliente(
        {
          idPasso: this.passo.id,
          idAcordo: this.passo.idAcordo,
          idUsuarioCliente: this.idUsuarioCliente,
        }, {})
        .then(this.transferidoComSucesso)
        .catch(this.erroRequisicao);
    },
    transferidoComSucesso() {
      this.$emit('filtrar', this.filtros);
      this.$toast.create(this.$t('message.aprovacao_transferida'), 'snack', 3E3);
      this.close();
    },
    erroRequisicao(err) {
      this.$error(this, err);
    },
    limparCampo() {
      this.grupos = null;
      this.subgrupos = null;
      this.usuariosAprovadores = null;
      this.idUsuarioCliente = null;
      this.valid = true;
      setTimeout(() => {
        if (this.ehCliente) {
          this.tipoAprovador = 'usuario';
        } else {
          this.tipoAprovador = null;
        }
      }, 1E2);
    },
    open() {
      this.limparCampo();
      setTimeout(() => this.buscarUsuarioClientePasso(), 1E2);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    buscarUsuarioClientePasso() {
      if (!this.ehCliente) return;
      if (this.passo.id) {
        this.buscarAprovadorPorPasso(this.passo.id);
      } else {
        this.buscarAprovadorPorUsuario(this.passo.idAprovador);
      }
    },
    buscarAprovadorPorUsuario(id) {
      this.usuarioClienteResources.obterUsuariosMesmaConfiguracaoUsuarioId({ id })
        .then((response) => {
          this.usuariosCliente = response.data.filter(u => u.id !== this.passo.idAprovador);
        })
        .catch(this.erroRequisicao);
    },
    buscarAprovadorPorPasso(idPassoExecucao) {
      this.fluxoExecucaoResource.aprovadoresPassosClientes({ idPassoExecucao })
        .then((response) => {
          this.usuariosCliente = response.data.filter(u => u.id !== this.passo.idAprovador);
        })
        .catch(this.erroRequisicao);
    },
    buscarUsuario() {
      const perfilId = this.idPerfilFiltro;
      const parametros = {
        nome: '',
        tamanhoPagina: 50000,
        tipo: 'FUNCIONARIO',
      };
      if (perfilId) {
        parametros.perfil = perfilId;
      }
      this.usuarioResources.listarAtivos(parametros)
        .then((response) => {
          this.usuarios = response.data.resposta.filter(u => u.id !== this.passo.idAprovador);
        })
        .catch(this.erroRequisicao);
    },
    buscarPerfil() {
      this.perfilResources.listarAtivos(
        {
          nome: '',
          indAtivo: true,
          tamanhoPagina: 50000,
        })
        .then((response) => {
          this.perfis = response.data.resposta;
        })
        .catch(this.erroRequisicao);
    },
    buscarEstruturas() {
      this.estruturaUsuarioResources.listarAtivos(
        {
          nome: '',
          indAtivo: true,
          tamanhoPagina: 50000,
        })
        .then((response) => {
          this.estruturas = response.data.resposta;
        })
        .catch(this.erroRequisicao);
    },
  },
  mounted() {
    this.buscarPerfil();
    this.buscarEstruturas();
    this.buscarUsuario();
  },
};



// WEBPACK FOOTER //
// ./src/spa/gestao-aprovacao/TransferirModal.vue?vue&type=script&lang=js&